<template>
    <div>
        <ProjectServicesTop />
        <div class="titleStyle">
            <div class="titleFont">大宗商品物流服务</div>
            <div class="conentFont">
                <div class="divide"></div>
                <span class="enFont">BULK COMMODITY LOGISTICS SERVICES</span>
                <div class="divide"></div>
            </div>
        </div>
      <div class="describeFont">
        {{ dataList.description }}
      </div>
        <div class="content">
            <div
                class="contentItem marginBom"
                v-for="(item, idx) in dataList.cmsArticleList"
                :key="idx"
                v-show="idx < 8"
                :style="{
                    backgroundImage: 'url(' + item.image + ')',
                }"
            >
                <div class="itemTitle">{{ item.title }}</div>
                <div class="itemContent">
                    {{ item.description }}
                </div>
                <div class="itemLine"></div>
            </div>
        </div>
    </div>
</template>
<script>
import ProjectServicesTop from "@/components/ProjectServicesTop.vue";
import { getAction } from "@/api/services";
export default {
    name: "CommodityLogisticsServices",
    components: {
        ProjectServicesTop,
    },
    data() {
        return {
            url: "/jhwlweb/gwweb/cmsArticleCategory/queryServiceList",
            dataList: [],
        };
    },
    created() {
        this.getInfo();
    },
    methods: {
        getInfo() {
            let that = this;
            let parmas = {
                menuCategory: 40,
            };
            getAction(that.url, parmas).then((res) => {
                if (res.code == 200 && res.success) {
                    that.dataList = res.result.records[0];
                }
            });
        },
    },
};
</script>
<style lang="less" scoped>
.describeFont {
  .typeArea();
  padding: 0 50px;
  font-size: 18px;
  letter-spacing: 1.1px;
  line-height: 1.6em;
  color: #333333;
  margin-bottom: 100px;
}
.oneOmit {
    white-space: nowrap; /*强调在同一行内显示所有文字，知道文本结束或者遭到br换行*/
    overflow: hidden; /*超出部分隐藏*/
    text-overflow: ellipsis; /*溢出部分用省略号代替*/
}
.bgSet {
    background-position: center center;
    background-size: cover;
    background-repeat: no-repeat;
}
.typeArea {
    max-width: 1100px;
    margin: 0 auto;
}
.titleStyle {
    .typeArea();
    padding-bottom: 80px;
    padding-top: 90px;
    text-align: center;
    width: 100%;
    .titleFont {
        font-family: "阿里巴巴普惠体";
        font-size: 32px;
        line-height: 28px;
        letter-spacing: 2px;
        color: #333333;
    }
    .conentFont {
        margin-top: 8px;
        .divide {
            display: inline-block;
            vertical-align: super;
            width: 20px;
            height: 2px;
            background-color: #0052d9;
        }
        .enFont {
            margin: 0 10px;
            font-family: "微软雅黑";
            font-size: 16px;
            letter-spacing: 0px;
            color: #333333;
            opacity: 0.5;
        }
    }
}
.content {
    .typeArea();
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    margin-bottom: 80px;
    .marginBom {
        margin-bottom: 20px;
    }
    .contentItem {
        .bgSet();
        width: 260px;
        height: 190px;
        position: relative;
        .itemTitle {
            position: absolute;
            left: 0;
            width: 260px;
            height: 190px;
            line-height: 190px;
            font-size: 32px;
            text-align: center;
            letter-spacing: 1px;
            color: #ffffff;
        }
        .itemContent {
            .oneOmit();
            opacity: 0;
            position: absolute;
            left: 0;
            bottom: 5px;
            width: 260px;
            padding: 20px;
            background-color: rgba(255, 255, 255, 0.6);
            font-size: 14px;
            letter-spacing: 0px;
            color: #333333;
        }
        .itemLine {
            position: absolute;
            left: 0;
            bottom: 0;
            width: 260px;
            height: 5px;
            background-color: #0052d9;
            opacity: 0;
        }
    }
    .contentItem:hover {
        .itemTitle {
            transition: all 0.2s ease-in;
            line-height: 120px;
        }
        .itemContent {
            transition: all 0.2s ease-in;
            opacity: 1;
        }
        .itemLine {
            transition: all 0.2s ease-in;
            opacity: 1;
        }
    }
}
</style>
